import { Truck, Leaf, Camera, CreditCard } from "lucide-react";

export const AdvantagesSection = ({ lang = "ru", t }) => {
  const advantages = [
    {
      icon: Truck,
      title: t ? t("adv.delivery.title") : "Быстрая доставка",
      description: t ? t("adv.delivery.desc") : "Доставим букет в день заказа в любой район города",
      color: "from-pink-500 to-rose-500",
    },
    {
      icon: Leaf,
      title: t ? t("adv.fresh.title") : "Свежие цветы",
      description: t ? t("adv.fresh.desc") : "Только свежие цветы от проверенных поставщиков",
      color: "from-emerald-500 to-teal-500",
    },
    {
      icon: Camera,
      title: t ? t("adv.photo.title") : "Фото перед отправкой",
      description: t ? t("adv.photo.desc") : "Отправим фото готового букета для согласования",
      color: "from-violet-500 to-purple-500",
    },
    {
      icon: CreditCard,
      title: t ? t("adv.payment.title") : "Удобная оплата",
      description: t ? t("adv.payment.desc") : "Принимаем оплату на карты любых банков и в любой валюте",
      color: "from-orange-500 to-amber-500",
    },
  ];

  return (
    <section id="advantages" className="py-12 sm:py-16 bg-gradient-to-b from-white to-pink-50" data-testid="advantages-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12">
          <h2 
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-2"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {t ? t("adv.title") : "Почему выбирают"}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-500">{t ? t("adv.titleAccent") : "нас"}</span>
          </h2>
        </div>

        <div className="flex flex-row justify-center gap-6 sm:gap-10 lg:gap-16 flex-wrap">
          {advantages.map((advantage, index) => {
            const IconComponent = advantage.icon;
            return (
              <div 
                key={index} 
                className="flex flex-col items-center text-center max-w-[140px] sm:max-w-[160px]"
                data-testid={`advantage-${index}`}
              >
                <div className={`w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-br ${advantage.color} flex items-center justify-center mb-4 shadow-xl hover:scale-110 transition-transform cursor-pointer`}>
                  <IconComponent className="w-7 h-7 sm:w-9 sm:h-9 text-white" />
                </div>
                <h3 className="text-sm sm:text-base font-bold text-gray-900 mb-1">{advantage.title}</h3>
                <p className="text-xs sm:text-sm text-gray-500 leading-relaxed">{advantage.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
